// import React, { useState } from "react";
// import { Accordion, Card, Form } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";

// const AddPermissionsBasicInformation = () => {
//   const { register } = useFormContext();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [modulePermissions, setModulePermissions] = useState([]);

//   // Fetch menu data from localStorage
//   const menuData = JSON.parse(localStorage.getItem("menus")) || [];

//   // Separate parent and child menu items
//   const parents = menuData.filter((menu) => menu.parentId === 0);
//   const children = menuData.filter((menu) => menu.parentId !== 0);

//   // Sort parents and map children to their respective parents
//   const sortedParents = parents.sort((a, b) => a.sortOrder - b.sortOrder);
//   const nestedData = sortedParents.map((parent) => ({
//     ...parent,
//     children: children
//       .filter((child) => child.parentId === parent.id)
//       .sort((a, b) => a.sortOrder - b.sortOrder),
//   }));

//   // Handle permission checkbox changes
//   const handlePermissionChange = (moduleId, permissionType) => (event) => {
//     const isChecked = event.target.checked;

//     setModulePermissions((prevPermissions) => {
//       const existingPermission = prevPermissions.find(
//         (permission) => permission.menuId === moduleId
//       );

//       if (existingPermission) {
//         return prevPermissions.map((permission) =>
//           permission.menuId === moduleId
//             ? { ...permission, [permissionType]: isChecked }
//             : permission
//         );
//       } else {
//         return [
//           ...prevPermissions,
//           {
//             roleId: location?.state?.id || 0,
//             menuId: moduleId,
//             allowList: false,
//             allowView: false,
//             allowDelete: false,
//             allowUpdate: false,
//             allowNew: false,
//             [permissionType]: isChecked,
//           },
//         ];
//       }
//     });
//   };

//   console.log(modulePermissions);

//   return (
//     <Card className="mb-3">
//       <Card.Header as="h6" className="bg-body-tertiary">
//         <div className="row">
//           <div className="col-md-3">Module Name</div>
//           <div className="col-md-4">Feature</div>
//           <div className="col-md-4 d-flex justify-content-between ">
//             <span>List</span>
//             <span>View</span>
//             <span>Add</span>
//             <span>Edit</span>
//             <span>Delete</span>
//           </div>
//         </div>
//       </Card.Header>
//       <Card.Body className="p-0">
//         <Accordion>
//           {nestedData.map((data, index) => (
//             <Accordion.Item key={data.id} eventKey={index.toString()}>
//               <Accordion.Header>
//                 <span className="fs-10 fw-medium">{data.name}</span>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {data.children.map((menu) => (
//                   <div key={menu.id} className="row py-2 align-items-center">
//                     <div className="col-md-3"></div>
//                     <div className="col-md-4 fs-10 fw-medium">{menu.name}</div>
//                     <div className="col-md-4 d-flex justify-content-between">
//                       {[
//                         "allowList",
//                         "allowView",
//                         "allowNew",
//                         "allowUpdate",
//                         "allowDelete",
//                       ].map((permission) => (
//                         <Form.Check
//                           key={permission}
//                           type="checkbox"
//                           id={`${menu.id}-${permission}`}
//                           label=""
//                           name={permission}
//                           onChange={handlePermissionChange(menu.id, permission)}
//                           checked={
//                             modulePermissions.find(
//                               (d) => d.menuId === menu.id
//                             )?.[permission] || false
//                           }
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </Accordion.Body>
//             </Accordion.Item>
//           ))}
//         </Accordion>
//       </Card.Body>
//     </Card>
//   );
// };

// export default AddPermissionsBasicInformation;

// import React, { useEffect, useState } from "react";
// import { Accordion, Card, Form } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation } from "react-router-dom";

// const AddPermissionsBasicInformation = () => {
//   const { register, setValue, watch } = useFormContext();
//   const location = useLocation();
//   const [modulePermissions, setModulePermissions] = useState([]);

//   const menuData = JSON.parse(localStorage.getItem("menus")) || [];

//   const parents = menuData.filter((menu) => menu.parentId === 0);
//   const children = menuData.filter((menu) => menu.parentId !== 0);

//   const sortedParents = parents.sort((a, b) => a.sortOrder - b.sortOrder);
//   const nestedData = sortedParents.map((parent) => ({
//     ...parent,
//     children: children
//       .filter((child) => child.parentId === parent.id)
//       .sort((a, b) => a.sortOrder - b.sortOrder),
//   }));

//   const handlePermissionChange = (moduleId, permissionType) => (event) => {
//     const isChecked = event.target.checked;

//     setModulePermissions((prevPermissions) => {
//       // Create a new array copy
//       let updatedPermissions = [...prevPermissions];

//       // Find index of existing permission
//       const existingPermissionIndex = updatedPermissions.findIndex(
//         (permission) => permission?.menuId === moduleId
//       );

//       if (existingPermissionIndex !== -1) {
//         // If permission exists, update it
//         updatedPermissions[existingPermissionIndex] = {
//           ...updatedPermissions[existingPermissionIndex],
//           [permissionType]: isChecked,
//         };
//       } else {
//         // If not found, add a new permission object
//         updatedPermissions.push({
//           roleId: location?.state?.id || 0,
//           menuId: moduleId,
//           allowList: false,
//           allowView: false,
//           allowDelete: false,
//           allowUpdate: false,
//           allowNew: false,
//           [permissionType]: isChecked, // Assign the changed permission
//         });
//       }

//       // Filter out any potential `null` values
//       updatedPermissions = updatedPermissions.filter(Boolean);

//       // Update form state to keep it in sync
//       setValue("permissions", updatedPermissions);

//       return updatedPermissions;
//     });
//   };

//   useEffect(() => {
//     setValue("permissions", modulePermissions);
//   }, [modulePermissions, setValue]);

//   return (
//     <Card className="mb-3">
//       <Card.Header as="h6" className="bg-body-tertiary">
//         <div className="row">
//           <div className="col-md-3">Module Name</div>
//           <div className="col-md-4">Feature</div>
//           <div className="col-md-4 d-flex justify-content-between">
//             <span>List</span>
//             <span>View</span>
//             <span>Add</span>
//             <span>Edit</span>
//             <span>Delete</span>
//           </div>
//         </div>
//       </Card.Header>
//       <Card.Body className="p-0">
//         <Accordion>
//           {nestedData.map((data, index) => (
//             <Accordion.Item key={data.id} eventKey={index.toString()}>
//               <Accordion.Header>
//                 <span className="fs-10 fw-medium">{data.name}</span>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {data.children.map((menu) => (
//                   <div key={menu.id} className="row py-2 align-items-center">
//                     <div className="col-md-3"></div>
//                     <div className="col-md-4 fs-10 fw-medium">{menu.name}</div>
//                     <div className="col-md-4 d-flex justify-content-between">
//                       {[
//                         "allowList",
//                         "allowView",
//                         "allowNew",
//                         "allowUpdate",
//                         "allowDelete",
//                       ].map((permission) => (
//                         <Form.Check
//                           key={permission}
//                           type="checkbox"
//                           id={`${menu.id}-${permission}`}
//                           label=""
//                           name={`permissions.${menu.id}.${permission}`}
//                           {...register(`permissions.${menu.id}.${permission}`)}
//                           onChange={handlePermissionChange(menu.id, permission)}
//                           checked={
//                             modulePermissions.find(
//                               (d) => d.menuId === menu.id
//                             )?.[permission] || false
//                           }
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </Accordion.Body>
//             </Accordion.Item>
//           ))}
//         </Accordion>
//       </Card.Body>
//     </Card>
//   );
// };

// export default AddPermissionsBasicInformation;

// import React, { useEffect, useState } from "react";
// import { Accordion, Card, Form } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation } from "react-router-dom";

// const AddPermissionsBasicInformation = () => {
//   const { setValue } = useFormContext();
//   const location = useLocation();
//   const [modulePermissions, setModulePermissions] = useState([]);

//   // Fetch menu data from localStorage
//   const menuData = JSON.parse(localStorage.getItem("menus")) || [];

//   // Separate parent and child menu items
//   const parents = menuData.filter((menu) => menu.parentId === 0);
//   const children = menuData.filter((menu) => menu.parentId !== 0);

//   // Sort parents and assign children
//   const sortedParents = parents.sort((a, b) => a.sortOrder - b.sortOrder);
//   const nestedData = sortedParents.map((parent) => ({
//     ...parent,
//     children: children
//       .filter((child) => child.parentId === parent.id)
//       .sort((a, b) => a.sortOrder - b.sortOrder),
//   }));

//   // Initialize all permissions on mount
//   useEffect(() => {
//     const initialPermissions = menuData
//       .filter((a) => a.parentId !== 0)
//       .map((menu) => ({
//         roleId: location?.state?.id || 0,
//         menuId: menu.id,
//         allowList: false,
//         allowView: false,
//         allowDelete: false,
//         allowUpdate: false,
//         allowNew: false,
//       }));

//     setModulePermissions(initialPermissions);
//     setValue("permissions", initialPermissions); // Sync with react-hook-form
//   }, [setValue, location?.state?.id]);

//   // Handle permission checkbox changes
//   const handlePermissionChange = (menuId, permissionType) => (event) => {
//     const isChecked = event.target.checked;

//     setModulePermissions((prevPermissions) => {
//       const updatedPermissions = prevPermissions.map((permission) =>
//         permission.menuId === menuId
//           ? { ...permission, [permissionType]: isChecked }
//           : permission
//       );

//       setValue("permissions", updatedPermissions); // Update form state
//       return updatedPermissions;
//     });
//   };

//   return (
//     <Card className="mb-3">
//       <Card.Header as="h6" className="bg-body-tertiary">
//         <div className="row">
//           <div className="col-md-3">Module Name</div>
//           <div className="col-md-4">Feature</div>
//           <div className="col-md-4 d-flex justify-content-between">
//             <span>List</span>
//             <span>View</span>
//             <span>Add</span>
//             <span>Edit</span>
//             <span>Delete</span>
//           </div>
//         </div>
//       </Card.Header>
//       <Card.Body className="p-0">
//         <Accordion>
//           {nestedData.map((data, index) => (
//             <Accordion.Item key={data.id} eventKey={index.toString()}>
//               <Accordion.Header>
//                 <span className="fs-10 fw-medium">{data.name}</span>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {data.children.map((menu) => (
//                   <div key={menu.id} className="row py-2 align-items-center">
//                     <div className="col-md-3"></div>
//                     <div className="col-md-4 fs-10 fw-medium">{menu.name}</div>
//                     <div className="col-md-4 d-flex justify-content-between">
//                       {[
//                         "allowList",
//                         "allowView",
//                         "allowNew",
//                         "allowUpdate",
//                         "allowDelete",
//                       ].map((permission) => (
//                         <Form.Check
//                           key={permission}
//                           type="checkbox"
//                           id={`${menu.id}-${permission}`}
//                           label=""
//                           onChange={handlePermissionChange(menu.id, permission)}
//                           checked={
//                             modulePermissions.find(
//                               (d) => d.menuId === menu.id
//                             )?.[permission] || false
//                           }
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </Accordion.Body>
//             </Accordion.Item>
//           ))}
//         </Accordion>
//       </Card.Body>
//     </Card>
//   );
// };

// export default AddPermissionsBasicInformation;

// import React, { useEffect, useState } from "react";
// import { Accordion, Card, Form } from "react-bootstrap";
// import { useFormContext } from "react-hook-form";
// import { useLocation } from "react-router-dom";

// const AddPermissionsBasicInformation = () => {
//   const { setValue, watch } = useFormContext();
//   const location = useLocation();
//   const permissions = watch("permissions");

//   // console.log(permissions);

//   const [modulePermissions, setModulePermissions] = useState([]);

//   // Fetch menu data from localStorage
//   const menuData = JSON.parse(localStorage.getItem("menus")) || [];

//   // Watch form values to update when binding permissions

//   useEffect(() => {
//     setModulePermissions(permissions || []);
//   }, [permissions]);

//   // Separate parent and child menu items
//   const parents = menuData.filter((menu) => menu.parentId === 0);
//   const children = menuData.filter((menu) => menu.parentId !== 0);

//   // Sort parents and assign children
//   const sortedParents = parents.sort((a, b) => a.sortOrder - b.sortOrder);
//   const nestedData = sortedParents.map((parent) => ({
//     ...parent,
//     children: children
//       .filter((child) => child.parentId === parent.id)
//       .sort((a, b) => a.sortOrder - b.sortOrder),
//   }));

//   // Handle permission checkbox changes
//   const handlePermissionChange = (menuId, permissionType) => (event) => {
//     const isChecked = event.target.checked;

//     setModulePermissions((prevPermissions) => {
//       const existingPermissionIndex = prevPermissions.findIndex(
//         (permission) => permission.menuId === menuId
//       );

//       let updatedPermissions = [...prevPermissions];

//       if (existingPermissionIndex !== -1) {
//         // Update existing permission
//         const updatedPermission = {
//           ...updatedPermissions[existingPermissionIndex],
//           [permissionType]: isChecked,
//         };

//         // Remove if all options are false
//         const hasAnyPermission = Object.keys(updatedPermission).some(
//           (key) =>
//             key !== "roleId" &&
//             key !== "menuId" &&
//             key !== permissionType &&
//             updatedPermission[key]
//         );

//         if (isChecked || hasAnyPermission) {
//           updatedPermissions[existingPermissionIndex] = updatedPermission;
//         } else {
//           updatedPermissions.splice(existingPermissionIndex, 1); // Remove from array
//         }
//       } else if (isChecked) {
//         // Add new permission only if checked
//         updatedPermissions.push({
//           roleId: location?.state?.id || 0,
//           menuId,
//           allowList: false,
//           allowView: false,
//           allowDelete: false,
//           allowUpdate: false,
//           allowNew: false,
//           [permissionType]: true, // Set the selected permission
//         });
//       }

//       setValue("permissions", updatedPermissions); // Update form state
//       return updatedPermissions;
//     });
//   };

//   return (
//     <Card className="mb-3">
//       <Card.Header as="h6" className="bg-body-tertiary">
//         <div className="row">
//           <div className="col-md-3">Module Name</div>
//           <div className="col-md-4">Feature</div>
//           <div className="col-md-4 d-flex justify-content-between">
//             <span>List</span>
//             <span>View</span>
//             <span>Add</span>
//             <span>Edit</span>
//             <span>Delete</span>
//           </div>
//         </div>
//       </Card.Header>
//       <Card.Body className="p-0">
//         <Accordion>
//           {nestedData.map((data, index) => (
//             <Accordion.Item key={data.id} eventKey={index.toString()}>
//               <Accordion.Header>
//                 <span className="fs-10 fw-medium">{data.name}</span>
//               </Accordion.Header>
//               <Accordion.Body>
//                 {data.children.map((menu) => (
//                   <div key={menu.id} className="row py-2 align-items-center">
//                     <div className="col-md-3"></div>
//                     <div className="col-md-4 fs-10 fw-medium">{menu.name}</div>
//                     <div className="col-md-4 d-flex justify-content-between">
//                       {[
//                         "allowList",
//                         "allowView",
//                         "allowNew",
//                         "allowUpdate",
//                         "allowDelete",
//                       ].map((permission) => (
//                         <Form.Check
//                           key={permission}
//                           type="checkbox"
//                           id={`${menu.id}-${permission}`}
//                           label=""
//                           onChange={handlePermissionChange(menu.id, permission)}
//                           checked={
//                             modulePermissions.find(
//                               (d) => d.menuId === menu.id
//                             )?.[permission] || false
//                           }
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </Accordion.Body>
//             </Accordion.Item>
//           ))}
//         </Accordion>
//       </Card.Body>
//     </Card>
//   );
// };

// export default AddPermissionsBasicInformation;

import React, { useEffect, useState } from "react";
import { Accordion, Card, Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";

const AddPermissionsBasicInformation = () => {
  const { setValue, watch } = useFormContext();
  const location = useLocation();
  const permissions = watch("permissions");
  const [modulePermissions, setModulePermissions] = useState([]);

  const menuData = JSON.parse(localStorage.getItem("menus")) || [];

  useEffect(() => {
    setModulePermissions(permissions || []);
  }, [permissions]);

  // Build nested structure recursively
  const buildNestedMenu = (parentId) => {
    const children = menuData
      .filter((menu) => menu.parentId === parentId)
      .sort((a, b) => a.sortOrder - b.sortOrder);

    return children.map((child) => ({
      ...child,
      children: buildNestedMenu(child.id),
    }));
  };

  const nestedData = buildNestedMenu(0);

  const handlePermissionChange = (menuId, permissionType) => (event) => {
    const isChecked = event.target.checked;

    setModulePermissions((prevPermissions) => {
      const existingIndex = prevPermissions.findIndex(
        (permission) => permission.menuId === menuId
      );

      let updated = [...prevPermissions];

      if (existingIndex !== -1) {
        const updatedPermission = {
          ...updated[existingIndex],
          [permissionType]: isChecked,
        };

        const hasAnyPermission = Object.entries(updatedPermission).some(
          ([key, value]) =>
            key !== "menuId" &&
            key !== "roleId" &&
            key !== permissionType &&
            value === true
        );

        if (isChecked || hasAnyPermission) {
          updated[existingIndex] = updatedPermission;
        } else {
          updated.splice(existingIndex, 1);
        }
      } else if (isChecked) {
        updated.push({
          roleId: location?.state?.id || 0,
          menuId,
          allowList: false,
          allowView: false,
          allowDelete: false,
          allowUpdate: false,
          allowNew: false,
          [permissionType]: true,
        });
      }

      setValue("permissions", updated);
      return updated;
    });
  };

  // Recursive render of menu rows
  const renderMenuRows = (menus, level = 1) => {
    return menus.map((menu) => (
      <React.Fragment key={menu.id}>
        <div className="row py-2 align-items-center">
          {/* <div
            className={`col-md-${level === 1 ? 3 : 3 - level + 1} ps-${
              level * 3
            }`}
          >
            {level > 1 && <span className="text-muted">↳</span>}
            {menu.name}
          </div> */}
          <div className={`col-md-3`}></div>
          <div className="col-md-4 fs-10 fw-medium">
            {/* {menu.name} */}
            {level > 1 ? (
              <div style={{ marginLeft: "50px" }}>{menu.name}</div>
            ) : (
              <div>{menu.name}</div>
            )}
          </div>
          <div className="col-md-4 d-flex justify-content-between">
            {[
              "allowList",
              "allowView",
              "allowNew",
              "allowUpdate",
              "allowDelete",
            ].map((permission) => (
              <Form.Check
                key={`${menu.id}-${permission}`}
                type="checkbox"
                id={`${menu.id}-${permission}`}
                label=""
                onChange={handlePermissionChange(menu.id, permission)}
                checked={
                  modulePermissions.find((d) => d.menuId === menu.id)?.[
                    permission
                  ] || false
                }
              />
            ))}
          </div>
        </div>
        {menu.children &&
          menu.children.length > 0 &&
          renderMenuRows(menu.children, level + 1)}
      </React.Fragment>
    ));
  };

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-body-tertiary">
        <div className="row">
          <div className="col-md-3">Module Name</div>
          <div className="col-md-4">Feature</div>
          <div className="col-md-4 d-flex justify-content-between">
            <span>List</span>
            <span>View</span>
            <span>Add</span>
            <span>Edit</span>
            <span>Delete</span>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        <Accordion>
          {nestedData.map((module, index) => (
            // <div key={module.id} className="row">
            <Accordion.Item key={module.id} eventKey={index.toString()}>
              <Accordion.Header>
                <span className="fs-10 fw-medium">{module.name}</span>
              </Accordion.Header>
              <Accordion.Body>{renderMenuRows(module.children)}</Accordion.Body>
            </Accordion.Item>
            // </div>
          ))}
        </Accordion>
      </Card.Body>
    </Card>
  );
};

export default AddPermissionsBasicInformation;
